module.exports = __webpack_public_path__ + "media/images/projects/job_icon-e96ad964ac0607a21b2aef207713556f.svg";